<div class="dcl-whats-included-modal-cta">
    <span class="di di-disney-cruise-line icon"></span>
    <div class="whats-included-text-container">
        <h4 class="whats-included-text" translate>{{ message }}</h4>
        <wdpr-button theme="secondary" (click)="onClick($event)" size="mini">
            <span class="button-text" translate>{{ buttonText }}</span>
        </wdpr-button>
    </div>
</div>
